import { z } from 'zod';

export const CategorySchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
});

export type Category = z.infer<typeof CategorySchema>;

export const CuisineSchema  = z.object({
  id: z.string().uuid(),
  name: z.string(),
});

export type Cuisine = z.infer<typeof CuisineSchema>;

export const IngredientSchema = z.object({
  id: z.string().uuid().nullish(),
  name: z.string(),
  amount: z.string().nullable(),
  unit: z.string().nullable(),
  original_text: z.string().nullable(),
  sort: z.number().gt(0).nullish(),
});

export type Ingredient = z.infer<typeof IngredientSchema>;

export const StepSchema = z.object({
  id: z.string().uuid().nullish(),
  name: z.string().nullable(),
  text: z.string().nullable(),
  sort: z.number().gt(0).nullish(),
});

export type Step = z.infer<typeof StepSchema>;


export const ImageSchema = z.object({
  id: z.string().uuid().nullish(),
  url: z.string().url(),
});

export type Image = z.infer<typeof ImageSchema>;

export const TagSchema = z.object({
  id: z.string().uuid().nullish(),
  name: z.string(),
})

export type Tag = z.infer<typeof TagSchema>;

export const UserSchema = z.object({
  id: z.string().uuid(),
  display_name: z.string(),
})

export type User = z.infer<typeof UserSchema>;

export const RecipeSchema = z.object({
  id: z.string().uuid().nullish(),
  user: UserSchema,
  name: z.string({message: 'Recipie must have a name'}).min(1),
  description: z.string().nullish(),
  source_url: z.string().nullish(),
  author: z.string().nullish(),
  yields: z.string().nullish(),
  prep_time: z.string().time().nullish(),
  cook_time: z.string().time().nullish(),
  total_time: z.string().time().nullish(),
  category: CategorySchema,
  cuisine: CuisineSchema,
  ingredients: z.array(IngredientSchema).default([]),
  steps: z.array(StepSchema).default([]),
  images: z.array(ImageSchema).default([]),
  tags: z.array(TagSchema).default([]),
});

export type Recipe = z.infer<typeof RecipeSchema>;

export const PaginationSchema = z.object({
  page: z.number().int(),
  limit:  z.number().int(),
  pages:  z.number().int(),
  total:  z.number().int(),
})

export type Pagination = z.infer<typeof PaginationSchema>;

export const GetRecipeResponseType = z.object({
  recipe: RecipeSchema,
});

export type GetRecipeResponse = z.infer<typeof GetRecipeResponseType>;

export const ListCategoryResponseType = z.object({
  results: z.array(CategorySchema),
});

export type ListCategoryResponse = z.infer<typeof ListCategoryResponseType>;

export const ListCuisineResponseType = z.object({
  results: z.array(CuisineSchema),
});

export type ListCuisineResponse = z.infer<typeof ListCuisineResponseType>;


export const PostRecipeResponseType = z.object({
  recipe: RecipeSchema,
});

export type PostRecipeResponse = z.infer<typeof GetRecipeResponseType>;

export const PutRecipeResponseType = z.object({
  recipe: RecipeSchema,
});

export type PutRecipeResponse = z.infer<typeof GetRecipeResponseType>;

export const RecipeSearchResponseType = z.object({
  results: z.array(RecipeSchema),
  pagination: PaginationSchema,
});

export type RecipeSearchResponse = z.infer<typeof RecipeSearchResponseType>;


export const LoginFormSchema = z.object({
  email: z.string().email({ message: 'Invalid email address' }),
  password: z.string(),
});

export type LoginForm = z.infer<typeof LoginFormSchema>;


export const NewPasswordSchema = z.object({
  password: z.string().min(8, 'Password must be at least 8 charaters long, contain a number, at elast one uppercase letter, and a special characters.'),
});

export type NewPasswordForm = z.infer<typeof NewPasswordSchema>;


export const ImportRecipeFormSchema = z.object({
  url: z.string().url({ message: 'Invalid url' }),
});

export type ImportRecipeForm = z.infer<typeof ImportRecipeFormSchema>;

export const ImportRecipeRequestSchema = z.object({
  url: z.string().url(),
});

export type ImportRecipeRequest = z.infer<typeof ImportRecipeRequestSchema>;

export const ImportRecipeResponseSchema = z.object({
  url: z.string().url(),
  status: z.string(),
  recipe_id: z.string().uuid().nullish(),
});

export type ImportRecipeResponse = z.infer<typeof ImportRecipeResponseSchema>;

export const UploadRecipeResponseSchema = z.object({
    file_id: z.string().uuid().nullish(),
    url: z.string().url(),
});

export type UploadRecipeResponse = z.infer<typeof UploadRecipeResponseSchema>;


export const ProcessUploadRequestSchema = z.object({
  file_id: z.string().uuid().nullish(),
});

export type ProcessUploadRequest = z.infer<typeof ProcessUploadRequestSchema>;

export const ProcessUploadResponseSchema = z.object({
    file_id: z.string().uuid().nullish(),
    status: z.string(),
    recipe_id: z.string().uuid().nullish(),
});

export type ProcessUploadResponse = z.infer<typeof ProcessUploadResponseSchema>;

